import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39e99459"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icdItem_wrap" }

import { ref, onMounted, toRefs, computed, watch } from 'vue'
import SearchModal from './SearchModal.vue'
import { Plus } from '@element-plus/icons-vue'

interface IIcd {
  icdCode: string
  icdName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: emits }) {

const props = __props as { modelValue: IIcd[] | undefined | string }




const { modelValue } = toRefs(props)

const SearchModalRef = ref<any>(null)

const icdList = computed<IIcd[]>(() => {
  if (Array.isArray(modelValue.value) && modelValue.value.length > 0) {
    return modelValue.value
  }
  return []
})

// 删除
function handleClose(item) {
  const newList = icdList.value.filter((itm) => itm.icdCode != item.icdCode)
  const value = Array.isArray(newList) && newList.length > 0 ? newList : ''
  emits('update:modelValue', value)
}
// 打开选择modal
function openModal() {
  SearchModalRef.value.open()
}
// 选择modal 确定
function handleModalSubmit(value: IIcd[] | undefined | '') {
  emits('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icdList), (item, index) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          class: "icdItem",
          key: item.icdCode,
          closable: "",
          "disable-transitions": false,
          onClose: ($event: any) => (handleClose(item))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.icdName), 1)
          ]),
          _: 2
        }, 1032, ["onClose"]))
      }), 128)),
      _createVNode(_component_el_button, {
        icon: _unref(Plus),
        circle: "",
        onClick: openModal
      }, null, 8, ["icon"])
    ]),
    _createVNode(SearchModal, {
      ref_key: "SearchModalRef",
      ref: SearchModalRef,
      initialValue: _unref(icdList),
      onSubmit: handleModalSubmit
    }, null, 8, ["initialValue"])
  ], 64))
}
}

})